<template>
  <div class="sidebar-item-box">
    <svg-icon v-if="icon" :iconClass="icon" style="width: 30px; height: 30px;"></svg-icon>
    <span slot='title'>{{title}}</span>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
